<script lang="ts">
  let { color = 'currentColor', strokeWidth = 1.2 } = $props()
</script>

<svg
  fill="none"
  height="16"
  viewBox="0 0 16 16"
  width="16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
    stroke={color}
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width={strokeWidth}
  />
  <path
    d="M7.99997 11.8769C10.1411 11.8769 11.8769 10.1411 11.8769 7.99997C11.8769 5.8588 10.1411 4.12305 7.99997 4.12305C5.8588 4.12305 4.12305 5.8588 4.12305 7.99997C4.12305 10.1411 5.8588 11.8769 7.99997 11.8769Z"
    stroke={color}
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width={strokeWidth}
  />
  <path
    d="M8.00078 8.70005C8.38738 8.70005 8.70078 8.38665 8.70078 8.00005C8.70078 7.61345 8.38738 7.30005 8.00078 7.30005C7.61418 7.30005 7.30078 7.61345 7.30078 8.00005C7.30078 8.38665 7.61418 8.70005 8.00078 8.70005Z"
    fill={color}
    stroke={color}
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width={strokeWidth}
  />
</svg>
